import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ModeMaintenanceComponent } from './pages/mode-maintenance/mode-maintenance.component';

const routes: Routes = [
  { path: 'auth', loadChildren: './pages/security/security.module#SecurityModule', data: { title: 'Login' } },
  { path: 'leads', loadChildren: './pages/leads/leads.module#LeadsModule', data: { title: 'Listado de Leads' } },
  { path: 'mylead/:id', loadChildren: './pages/my-lead/my-lead.module#MyLeadModule', data: { title: 'Detalle de lead' } },
  { path: 'metrics', loadChildren: './pages/metrics/metrics.module#MetricsModule', data: { title: 'Métricas' } },
  { path: 'reporting', loadChildren: './pages/reporting/reporting.module#ReportingModule', data: { title: 'Reporting' } },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', data: { title: 'Dashboad Admin' } },
  { path: 'planning', loadChildren: './pages/calendar/calendar.module#CalendarModule', data: { title: 'Calendario' } },
  { path: 'mode-maintenance', component: ModeMaintenanceComponent, data: { title: 'Calendario' } },
  { path: 'v2/dashboard', loadChildren: './pages/new-dashboard/new-dashboard.module#NewDashboardModule', data: { title: 'Calendario' } },
  { path: 'investment', loadChildren: './pages/investment/investment.module#InvestmentModule', data: { title: 'Calculadora de Marketing' } },
  { path: 'analytics', loadChildren: './pages/analytics/analytics.module#AnalyticsModule', data: { title: 'Análisis' } },
  { path: 'dashboard-bdc', loadChildren: './pages/dashboard-bdc/dashboard-bdc.module#DashboardBdcModule', data: { title: 'Dashboard BDC' } },
  { path: 'profile', loadChildren: './pages/profile/profile.module#ProfileModule', data: { title: 'Perfil' } },
  { path: 'quotations', loadChildren: './pages/quotations/quotations.module#QuotationsModule', data: { title: 'Presupuestos' } },
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' }
];

const config: ExtraOptions = {
  useHash: true
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
